export default {
      id: "adverts-usage",
      viewBox: "0 0 64 80",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#adverts-usage",
      toString: function () {
        return this.url;
      }
    }